import { Provider as ReduxProvider } from "react-redux";

import { AppToast, EukaBarkProvider } from "@euka-mfes/bark";
import { Toast } from "@/components/Toast";
import { store } from "@/store";
import EchoProvider from "@providers/EchoProvider";
import "@styles/main.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import RouteErrorBoundary from "@providers/RouteErrorBoundary";

interface PropTypes {
    children: React.ReactNode;
}

const queryClient = new QueryClient();

const persistor = persistStore(store);

const AppProvider = ({ children }: PropTypes) => {
    return (
        <RouteErrorBoundary>
            <ReduxProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <EukaBarkProvider forcedTheme="light">
                        <QueryClientProvider client={queryClient}>
                            <EchoProvider>{children}</EchoProvider>
                        </QueryClientProvider>
                        <Toast />
                        <AppToast />
                    </EukaBarkProvider>
                </PersistGate>
            </ReduxProvider>
        </RouteErrorBoundary>
    );
};

export default AppProvider;
